
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.784 8.971l.692-.707a2.525 2.525 0 01-.771-.18 1.692 1.692 0 01-.546-.369 2.016 2.016 0 01-.56-.915 1.858 1.858 0 010-1.005c.093-.333.278-.638.554-.915l1.6-1.594c.273-.277.578-.462.913-.554a1.85 1.85 0 011.002 0c.333.092.64.275.92.548.277.28.462.588.554.923.092.335.091.67-.003 1.003a2.078 2.078 0 01-.55.91l-.883.887A1.95 1.95 0 019.83 8.09l1.4-1.4c.397-.397.66-.832.792-1.308.132-.475.131-.95-.002-1.427-.134-.477-.399-.914-.795-1.31-.396-.397-.833-.662-1.31-.795a2.599 2.599 0 00-1.428 0c-.475.133-.909.396-1.302.79L5.507 4.316c-.39.393-.65.827-.781 1.302a2.648 2.648 0 00-.003 1.428c.13.477.393.914.79 1.31.147.147.322.273.525.377.203.104.452.184.746.238zm-1.405 3.066c.475-.133.91-.395 1.302-.784l1.672-1.677c.393-.393.656-.828.79-1.305.133-.476.134-.952.002-1.427-.132-.475-.397-.913-.797-1.313a2.182 2.182 0 00-.52-.372 2.66 2.66 0 00-.747-.238l-.697.702c.3.028.558.088.772.18.213.092.399.215.556.369.273.277.456.583.549.918.092.335.092.67 0 1.005-.093.335-.276.639-.549.912l-1.6 1.595c-.276.28-.582.466-.915.559a1.849 1.849 0 01-1.002 0 2.036 2.036 0 01-.913-.554 2.05 2.05 0 01-.559-.918 1.85 1.85 0 010-1.002c.093-.333.277-.639.554-.915l.877-.882a1.862 1.862 0 01-.139-.539 1.826 1.826 0 01.021-.548l-1.405 1.4c-.39.396-.65.83-.782 1.304a2.639 2.639 0 00-.002 1.426c.13.476.393.915.79 1.315.4.396.838.66 1.314.792.477.131.953.13 1.428-.003z","fill":"#41807A"}})])
          )
        }
      }
    